import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { ChainId } from 'sdk'
import { fetchData, getPriceUSDApiUrl, PRICE_GRAPH_API } from 'config/constants/endpoints'

export const PriceUSDContext = createContext<any>(undefined)

function usePriceUSDContext() {
  return useContext(PriceUSDContext)
}

export const PriceUSDProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<any>({})
  const { chainId } = useActiveWeb3React()

  useEffect(() => {
    const balanceUpdater = async () => {
      try {
        const _chainId = chainId || ChainId.MAINNET
        const reqURL = getPriceUSDApiUrl(_chainId)

        const response = await fetchData(PRICE_GRAPH_API, reqURL, 'get', undefined, PRICE_GRAPH_API)

        const result = await response.json()

        setData(result)
      } catch (error) {
        setData({})
      }
    }
    balanceUpdater()
  }, [chainId])
  return (
    <PriceUSDContext.Provider value={useMemo(() => [data, { setData }], [data, setData])}>
      {children}
    </PriceUSDContext.Provider>
  )
}

export function useTokenPriceUSD(currency?: any, amount?: number | string): string {
  const [data] = usePriceUSDContext()
  let _amount = amount
  if (!_amount) _amount = 0

  const { nativeTokenPriceUSD, tokenPricesMap } = data

  if (!nativeTokenPriceUSD || !currency) return ''

  if (!currency.address) return `${(Number(nativeTokenPriceUSD) * Number(_amount)).toFixed(2)}`

  const price = tokenPricesMap[currency.address.toLowerCase()]
  if (!price || !currency.decimals) return ''

  return `${((Number(nativeTokenPriceUSD) * Number(price) * Number(_amount)) / 10 ** 18).toFixed(2)}`
}
